var Video_Akrolab = {
    _hasMoved:false,
    init:function(){
        $("body").on("touchmove", ".video-player-akrolab", function(e){
           Video_Akrolab._hasMoved = true;
        });

        $("body").on("click touchend", ".video-player-akrolab", function(e){
            if(e.type == "touchend"){
                $("body").off("click", ".video-player-akrolab");
            }

            if(Video_Akrolab._hasMoved == false){
                if($(this).hasClass("playing")){
                    Video_Akrolab.stop_video($(this));
                }else{
                    $(".video-player-akrolab").each(function(){
                        if($(this).hasClass("playing")){
                            Video_Akrolab.stop_video($(this));
                        }
                    })
                    Video_Akrolab.play_video($(this));
                }
            }
            Video_Akrolab._hasMoved = false;
        })
    },
    stop_video:function(pTarget){

        pTarget.removeClass("playing");
        pTarget.find("video").get(0).pause();
        pTarget.find("video").get(0).currentTime = 0;

        /*pTarget.find("video").attr('controls', false);*/
    },
    play_video:function(pTarget){

        pTarget.addClass("playing");
        pTarget.find("video").get(0).play();
        /*pTarget.find("video").attr('controls',true);*/
    }

}

$(window).on("load", function(){
    if($(".video-player-akrolab").length){
        Video_Akrolab.init();
    }
})